import React from "react";
import { FileText, MessageSquare, Rocket } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: <FileText size={22} />,
    title: "Tell me about your project",
    body:
      "Fill out the form, message me on Fiverr, or email support@melavatestudios.com. Share what you need, your timeline, and any reference materials.",
  },
  {
    n: "02",
    icon: <MessageSquare size={22} />,
    title: "I scope, quote, and confirm",
    body:
      "Within 24 hours, you'll get a clear scope, a fixed price, and a delivery date. No surprise fees, no scope-creep — promise.",
  },
  {
    n: "03",
    icon: <Rocket size={22} />,
    title: "I build. You review. We launch.",
    body:
      "I deliver the work within the agreed window. Two rounds of revisions included. When you're thrilled, we wrap and you go live.",
  },
];

const PROMISES = [
  { number: "24h", label: "Reply time, guaranteed" },
  { number: "3–7d", label: "Average project turnaround" },
  { number: "2", label: "Revision rounds included" },
  { number: "100%", label: "Built by Melanie — never outsourced" },
];

export default function HowItWorks() {
  return (
    <section id="process" data-testid="process-section" className="bg-cream section-pad">
      <div className="container-edit">
        <div className="max-w-2xl mb-16">
          <div className="eyebrow mb-5">How It Works</div>
          <h2 className="h-section text-plum-deepest">
            A simple, honest <span className="font-display-italic text-gold-deep">three-step</span> process.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-20">
          {STEPS.map((s) => (
            <div
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className="relative bg-cream-pale rounded-2xl p-7 border border-plum/8"
            >
              <div className="flex items-center justify-between mb-6">
                <span className="font-display-italic text-5xl text-gold/40">{s.n}</span>
                <span className="text-plum">{s.icon}</span>
              </div>
              <h3 className="h-card text-plum-deepest mb-3">{s.title}</h3>
              <p className="text-sm text-muted-plum leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>

        <div className="card-plum">
          <div className="text-center mb-8">
            <div className="eyebrow text-gold mb-3">The Melavate Promise</div>
            <h3 className="font-display text-3xl md:text-4xl text-cream">
              What you get, every single time.
            </h3>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 pt-6 border-t border-gold/20">
            {PROMISES.map((p, i) => (
              <div key={i} className="text-center">
                <div className="font-display text-4xl text-gold mb-2">{p.number}</div>
                <div className="text-cream/80 text-sm">{p.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
